import React, { useState, useRef, useEffect } from "react";
import "../Bfsi Solution/faq.css";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const answerRefs = useRef([]);

  const faqs = [
    {
      q: "What Services Does Your Sports and Gaming Software Development Company Offer?",
      a: "We offer a range of services, including sports app development, gaming software solutions, augmented reality (AR) experiences, fantasy sports platforms, and more.",
    },
    {
      q: "Can You Develop Custom Sports and Gaming Applications Tailored to Specific Requirements?",
      a: "Absolutely. We specialize in developing customized sports and gaming solutions to meet the unique needs and preferences of our clients.",
    },
    {
      q: "Do You Have Experience in Developing Fantasy Sports Platforms With Features Like Player Drafting and Scoring?",
      a: "Yes, we have extensive experience in developing fantasy sports platforms with features like player drafting, real-time scoring, and user engagement elements.",
    },
    {
      q: "How Do You Ensure the Security of Gaming Platforms and Prevent Cheating in Online Games?",
      a: "We implement robust security measures, including encryption protocols, secure user authentication, and anti-cheat mechanisms to ensure fair play.",
    },
    {
      q: "Can Your Gaming Software Be Integrated With Popular Gaming Consoles and Platforms?",
      a: "Yes, we ensure compatibility and integration with popular gaming consoles and platforms, providing a seamless gaming experience.",
    },
    {
      q: "What Technologies Do You Use for Developing Sports and Gaming Software?",
      a: "We leverage cutting-edge technologies such as AR, VR, and advanced gaming engines to create immersive and feature-rich sports and gaming experiences.",
    },
    {
      q: "How Do You Handle Live Scores and Real-time Updates in Sports Applications?",
      a: "We integrate real-time data feeds, APIs, and scoring systems to provide users with live scores, play-by-play updates, and real-time statistics.",
    },
    {
      q: "Can Your Sports Applications Support Live Streaming of Sports Events?",
      a: "Yes, we can incorporate live streaming features for sports events, enhancing the viewing experience for users.",
    },
    {
      q: "What Types of Gamification Elements Can Be Included in Gaming Applications?",
      a: "We can include various gamification elements such as leaderboards, achievements, rewards, and in-game challenges to enhance user engagement.",
    },
    {
      q: "Do You Offer E-sports Development Services for Competitive Online Gaming?",
      a: "Yes, we specialize in e-sports development, creating platforms for competitive online gaming, tournaments, and leagues.",
    },
     {
      q: "Can Your Sports and Gaming Applications Be Accessed on Multiple Platforms, Including Mobile Devices and Smart Tvs?",
      a: "Yes, we ensure multi-platform compatibility, allowing users to access applications on web browsers, mobile devices, and smart TVs.",
    },
    {
      q: "How Do You Approach the Development of Augmented Reality (Ar) and Virtual Reality (Vr) Experiences in Sports and Gaming?",
      a: "We use AR and VR technologies to create immersive experiences, including virtual stadium tours, AR-enhanced game previews, and VR live streaming.",
    },
  ];

  const toggleFaq = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  // Get height for smooth animation
  const getHeight = (index) => {
  const el = answerRefs.current[index];
  if (!el) return "0px";

  const padding = 40; // top 20 + bottom 20
  return `${el.scrollHeight + padding}px`;
};


  return (
    <div className="faq-wrapper">
      <h2 className="faq-title">Faq's</h2>

      {faqs.map((item, index) => (
        <div
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
          key={index}
        >
          <div className="faq-question" onClick={() => toggleFaq(index)}>
            <span>{item.q}</span>
            <span className="faq-icon">
              {activeIndex === index ? "−" : "+"}
            </span>
          </div>

          {/* Smooth answer */}
          <div
            className="faq-answer"
            ref={(el) => (answerRefs.current[index] = el)}
            style={{
              maxHeight: activeIndex === index ? getHeight(index) : "0px",
            }}
          >
            <p>{item.a}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
